module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.acfcc98.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.ttf
// module id = azoL
// module chunks = 12